var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shootlist",staticStyle:{"color":"#63ADE6"}},[_vm._v(" "+_vm._s(_vm.getName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }